import { dayNumberInData } from "../functions";
import { mean } from "mathjs";
import type { CalcOptions, NumberMatrix } from "../algorithm.types";

type CalculateAverageGenerationParams = {
  calcOptions: Pick<
    CalcOptions,
    "noOfTechs" | "season" | "dayOfTheSeason" | "noOfDaysPerSeason"
  >;
  genData: NumberMatrix;
  averageGenPerDay: NumberMatrix;
};

export default function calculateAverageGeneration({
  calcOptions,
  genData,
  averageGenPerDay,
}: CalculateAverageGenerationParams): NumberMatrix {
  const { noOfTechs, season, dayOfTheSeason, noOfDaysPerSeason } = calcOptions;

  for (let i = 0; i < noOfTechs; i++) {
    averageGenPerDay[i][
      dayNumberInData(season, dayOfTheSeason, noOfDaysPerSeason)
    ] = mean(genData[i]);
  }

  return averageGenPerDay;
}
